const UUID_V5_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-5[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function parseConversionEventId(value: unknown): string | undefined {
  if (typeof value !== "string") return undefined;
  const eventId = value.trim();
  return UUID_V5_PATTERN.test(eventId) ? eventId : undefined;
}
